<template>
  <div class="flex bg-bg-base-bg1 h-screen w-screen items-center justify-center">
    <div class="flex items-center justify-center">
      <logo-animated class="w-[163px] h-[163px]" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { LogoAnimated } from '@/shared/components/logo'
</script>
